import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ContainerQueryContext } from '../../util/ContainerQuery.context';

import * as Styled from './Badge.styled';

/**
 * A non-interactive visual component to highlight a feature, quality, or other type of messaging to the customer on a product card
 */
const Badge = ({ text, badgeColor }) => {
  const { styleQueryMode } = useContext(ContainerQueryContext);
  return (
  <Styled.Badge $badgeColor={badgeColor} $styleQueryMode={styleQueryMode}>{text}</Styled.Badge>
)};

Badge.propTypes = {
  /**
   * The main text of the badge
   */
  text: PropTypes.string,
  /**
   * The color of the badge
   *
   * Colors are passed as a name which is then matched to Bombas brand colors for the hex
   */
  badgeColor: PropTypes.oneOf([
    'black',
    'blue',
    'blue20',
    'grey20',
    'grey40',
    'grey60',
    'grey80',
    'green',
    'red',
    'white'
  ])
};

Badge.defaultProps = {
  text: '',
  badgeColor: 'green'
};

export default Badge;
